import * as React from "react";
import { Link } from "react-router-dom";
import { cn } from "../../../lib/utils";
import { Button, buttonVariants } from "../button";

export const Cta = ({ cta }) => {
  const { text, link, variant = "default", size = "default", ctaEnabled } = cta;

  if (!ctaEnabled) return null;

  const className = cn(buttonVariants({ variant, size }));

  if (link && (link.startsWith("http") || link.startsWith("/"))) {
    return (
      <Link to={link} className={className}>
        {text}
      </Link>
    );
  }

  return (
    <Button variant={variant} size={size} asChild>
      <Link to={link || "#"}>{text}</Link>
    </Button>
  );
};

export const CtaProps = {
  ctaEnabled: false,
  text: "",
  link: "",
  variant: "default",
  size: "default",
};
